import React, { Component } from "react";
import { Media } from "reactstrap";
import { toggleStyleSheet, clearAllStyles } from "../helpers/accessability";
import { joinCss } from "../helpers/utils";
import { Link } from "react-router-dom";

import accessabilityImg from "../images/accessability.png";

//import fa from "../css/fontawesome-free-5.8.1-web/fontawesome.scss";
import classes from "./AriaMenu.module.scss";

class AriaMenu extends Component {
  constructor(props) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggleMenu() {
    document
      .getElementById("accessability-menu-container")
      .classList.toggle("d-block"); //accessability-menu-container
    document
      .getElementById("accessability-menu-container")
      .classList.toggle("d-none"); //accessability-menu-container
  }
  render() {
    return (
      <div className="non-accessible" className={classes.accessabilityWidget}>
        <div
          id="accessability-menu-container"
          className={joinCss(classes.menu, "float-right non-accessible d-none")}
        >
          <ul className="non-accessible">
            <li className="non-accessible" id="medium-contrast">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("medium-contrast")}
                  title="ניגודיות בינונית"
                >
                  <i className="fa fa-adjust" aria-hidden="true" /> ניגודיות
                  בינונית
                </a>
              </div>
            </li>
            <li className="non-accessible" id="high-contrast">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("high-contrast")}
                  title="ניגודיות גבוהה"
                >
                  <i className="fa fa-adjust" aria-hidden="true" /> ניגודיות
                  גבוהה
                </a>
              </div>
            </li>
            <li className="non-accessible" id="monochrome">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("monochrome")}
                  title="מונוכרום"
                >
                  <i className="fa fa-broom" aria-hidden="true" /> מונוכרום
                </a>
              </div>
            </li>
            <li className="non-accessible" id="underline-links">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("underline-links")}
                  title="הדגשת קישורים"
                >
                  <i className="fa fa-link" aria-hidden="true" /> הדגשת קישורים
                </a>
              </div>
            </li>
            <li className="non-accessible" id="zoom-out">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("zoom-out")}
                  title="הגדל פונט"
                >
                  <i className="fa fa-expand" aria-hidden="true" />
                  הגדל פונט
                </a>
              </div>
            </li>
            <li className="non-accessible" id="zoom-in">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("zoom-in")}
                  title="הקטן פונט"
                >
                  <i className="fa fa-compress" aria-hidden="true" />
                  הקטן פונט
                </a>
              </div>
            </li>
            <li className="non-accessible" id="readable-font">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => toggleStyleSheet("readable-font")}
                  title="פונט קריא"
                >
                  <i className="fa fa-font" aria-hidden="true" /> פונט קריא
                </a>
              </div>
            </li>
            <li className="non-accessible">
              <div>
                <a
                  className="non-accessible"
                  onClick={() => clearAllStyles()}
                  title="נקה הגדרות נגישות"
                >
                  <i className="fa fa-eraser" aria-hidden="true" /> נקה הגדרות
                  נגישות
                </a>
              </div>
            </li>
            <li className="non-accessible">
              <div>
                <Link to={{ pathname: "/AccessabilityDeclaration" }}>
                  <i className="fa fa-info" aria-hidden="true" /> אודות נגישות
                  באתר
                </Link>
              </div>
            </li>
            <li className="non-accessible">
              <div>
                <a
                  className="non-accessible"
                  onClick={this.toggleMenu}
                  title="סגור"
                >
                  <i className="fa fa-times" aria-hidden="true" /> סגור
                </a>
              </div>
            </li>
          </ul>
        </div>

        <div
          className="float-right non-accessible"
          id="btn-accessability"
          onClick={this.toggleMenu}
          //data-toggle="popover"
          title="פתח תפריט נגישות"
        >
          <Media object alt="נגישות" src={accessabilityImg} />
        </div>
      </div>
    );
  }
}

export default AriaMenu;
